const navOptions: { titleKey: string; section: string }[] = [
  {
    titleKey: "nav.home",
    section: "Home",
  },
  {
    titleKey: "nav.ourStory",
    section: "OurStory",
  },
  {
    titleKey: "nav.gallery",
    section: "Gallery",
  },
  {
    titleKey: "nav.locations",
    section: "Contact",
  },
  {
    titleKey: "nav.journal",
    section: "Posts",
  },
  {
    titleKey: "nav.faqs",
    section: "Faqs",
  },
];
export default navOptions;
